import moment from 'moment-timezone'

/**
 * フォーマットされた時間を取得
 */
export function getTimeFormat(datetime: Date | string, format = 'lll'): string {
  return moment(datetime).format(format)
}
